import { useLoaderData } from 'react-router';
import { gql } from '@/__generated__';
import { preloadQuery } from '@/apollo/apollo-client';
import { Route } from './+types/route';

export const UserStatisticsQuery = gql(`
  query UserStatisticsQuery($username: String!) {
    user(username: $username) {
      id
      ...MainStatisticProfileFragment
      ...UserTournamentsSection
    }
  }
`);

export const profileLoader = ({
  params: { username },
}: Route.ClientLoaderArgs) => {
  return {
    profileQueryRef: preloadQuery(UserStatisticsQuery, {
      variables: { username },
      fetchPolicy: 'cache-and-network',
    }),
  };
};

type LoaderData = ReturnType<typeof profileLoader>;

export const useProfileLoaderData = () => useLoaderData() as LoaderData;
